import UserSettings from "../../components/modals/PersonModal/UserSettings";

export function PublicInfo(props: {
    userObj: IPersonBlock
}) {
    return <div id="my-public-information-tab">
        <div className="sb-settings-block-content-heading">
            <h4>My Public Information</h4>
            <p>The following is called a "Contact Card". Any of the information in the contact card is
                considered public. If you have been defined by your school or district as a staff
                member or teacher, then you can select and view where your Contact Card is shown.</p>
        </div>
        <div id="teacherModal">
            <UserSettings blockObj={props.userObj} isPublicInfo={true}/>
        </div>
    </div>
}